import React from "react";

export default function WhoDeveloped() {
  return (
    <div className="whoDeveloped">
      <p>
        developed by Musobek Madrimov <br />
        <a href="https://github.com/musobekmadrimov/" target="_blank" rel="noreferrer">
          github.com/musobekmadrimov
        </a>
      </p>
    </div>
  );
}
